export const defaultLayoutComponents = {
	appbar: () => import('./app-bar/app-bar.vue'),
	nav: () => import('./app-navigation/app-navigation.vue')
};

export const appBar = {
	appbar: () => import('./app-bar/app-bar.vue')
};

export const settingsLayoutComponents = {
	appbar: () => import('./app-bar/settings-bar.vue'),
	nav: () => import('./app-navigation/settings-navigation.vue')
};
